class GiftComponent extends HTMLElement {
  connectedCallback() {
    const id = this.getAttribute('id');
    const quantity = this.getAttribute('quantity');
    //IF quantity is 0, remove the item from the cart
    let cartURL = '/cart/add.js';
    JSON.stringify({
      id: id,
      quantity: quantity,
    });
    if (quantity == 0) {
      cartURL = '/cart/update.js';
      JSON.stringify({
        id: quantity,
      });
    }
    fetch(cartURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: id,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        this.dispatchEventGiftAdded(id, quantity);
      });
  }

  dispatchEventGiftAdded(id, quantity) {
    console.log('dispatchEventGiftAdded', id, quantity);
    window.dispatchEvent(
      new CustomEvent('giftAdded', {
        detail: {
          id: id,
          quantity: quantity,
        },
      })
    );
  }
}

customElements.define('gift-component', GiftComponent);
